// Customization button moved to Header — this file is now a no-op shell.
const Customization = () => null;
export default Customization;
